// extracted by mini-css-extract-plugin
module.exports = {"group":"Input_group__1cM2T","label":"Input_label__SIz-j form_label__FEn27 typography_heading3__2drgN","input":"Input_input__18agt form_input__iIRHz typography_heading3__2drgN"};